import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

// import Navigation from '../Navigation';
// import LandingPage from '../Landing';
// import SignUpPage from '../SignUp';
// import indexRoutes from 'routes';
import SignInPage from 'components/SignIn/SignIn';
import SignUpPage from 'components/SignIn/SignUp';
import PasswordForgetPage from 'components/SignIn/PasswordForget';
// import PasswordForgetPage from '../PasswordForget';
// import HomePage from 'component/home';
// import Dashboard from 'layouts/Dashboard/Dashboard';
import Cabinet from 'components/Cabinet/Cabinet';
// import AccountPage from '../Account';

import auth from 'layouts/Auth/auth';
import * as routes from 'constants/routes';


const App = () =>
	<Router>
		<div className="App">
		{/*<Navigation />*/}

			{/*<Route exact path={routes.LANDING} component={() => <LandingPage />} />*/}
			{/*<Route exact path={routes.SIGN_UP} component={() => <SignUpPage />} />*/}
			<Route exact path='/' component={() => <SignInPage />} />
			<Route exact path='/signup' component={() => <SignUpPage />} />
			<Route exact path={routes.PASSWORD_FORGET} component={() => <PasswordForgetPage />} />
			<Route exact path={routes.HOME} component={() => <Cabinet />} />
			{/*<Route exact path={routes.ACCOUNT} component={() => <AccountPage />} />*/}
			{/*{indexRoutes.map((prop, key) => {
        		return <Route to={prop.path} component={prop.component} key={key} />;
      		})}*/}


		</div>
	</Router>

export default auth(App);


// WEBPACK FOOTER //
// ./src/components/App/App.jsx